import React from 'react'
import { Link } from 'react-router-dom'
import Appdtore from "../../images/5a902db97f96951c82922874.png"
import Androi from "../../images/adroi.png"
export default function Footer() {
    return (
        <>
            <footer className='footer p-2 fixed-bottom'>
                <div className="container">
                    <div className="intro-foot">
                    <h5>Get the FreshCart app</h5>
                    <p className='text-secondary'>We will send you a link, open it on your phone to download the app.</p>
                    </div>
                
                <div className="box d-flex flex-wrap justify-content-center align-items-center gap-2">
                    <input className='cont rounded border-0 p-1' type="email" name="email" id="email" placeholder='Email ..' />
                    <Link className='cont1' to={"/"}><button className='bg-main rounded text-white py-1  px-5 border border-0 '>Share App Link</button></Link>
                </div>
                <div className="d-flex justify-content-between align-items-center boxfoot py-2 my-3">
                <ul className='d-flex flex-wrap justify-content-between gap-2 m-0'>
                    <li className='m-0'>Payment Partners</li>
                    <div className='d-flex justify-content-center align-items-center gap-2'>
                    <li><Link to={"www.amazon.com"}><i className="fa-brands fa-cc-amazon-pay text-warning"></i></Link></li>
                    <li><Link to={"www.mastercard.com"}><i className="fa-brands fa-cc-mastercard text-danger"></i></Link></li>
                    <li><Link to={"www.paypal.com"}><i className="fa-brands fa-cc-paypal text-info"></i></Link></li>
                    </div>
                    
                </ul>
                <div className="box d-flex flex-wrap justify-content-center align-items-center gap-2">
                    <p className='m-0'>Get deliveries with FreshCart</p>
                    <div className="image">
                        <Link to={"https://www.apple.com/"}><img  className='w-100' src={Appdtore} alt="" /></Link>
                    </div>
                    <div className="image">
                    <Link to={"https://play.google.com/"}><img className='w-100' src={Androi} alt="" /></Link>
                        
                    </div>
                </div>
                </div>
                </div>
            </footer>
        </>
    )
}
